import dayjs from "dayjs";
import { IBundleItem, IRouteLeg } from "../Models";

export const krogenSlots = [
	{ slotName: "frukost1", productCodes:  ["BIK1", "VBIK1"], startTime: "05:30", endTime:  "10:45", departureDayOffset: 0, type: "breakfast" },
	{ slotName: "lunch1", productCodes: ["LIK1", "LIKH1", "VLIK1", "VLIKH1"], startTime: "11:00", endTime: "14:45", departureDayOffset: 0, type: "lunch" },
	{ slotName: "middag1",  productCodes: ["DIK", "DIKH", "VDIK", "VDIKH"], startTime: "15:00", endTime: "23:45", departureDayOffset: 0, type: "dinner" },
	{ slotName: "frukost2", productCodes:  ["BIK", "VBIK"], startTime: "05:30", endTime:  "10:45", departureDayOffset: 1, type: "breakfast" },
	{ slotName: "lunch2", productCodes: ["LIK", "LIKH", "VLIK", "VLIKH"], startTime: "11:00", endTime: "14:45", departureDayOffset: 1, type: "lunch" },
	{ slotName: "middag2",  productCodes: ["DIK2", "DIKH2", "VDIK2", "VDIKH2"], startTime: "15:00", endTime: "23:45", departureDayOffset: 1, type: "dinner" },

] as IKrogenSlot[];

export function getKrogenSlotForProductCode(productCode: string) : IKrogenSlot|undefined {
	return krogenSlots.find(x => x.productCodes.includes(productCode));
}

export const getKrogenProductCodes = () => krogenSlots.flatMap(x => x.productCodes);

export interface IKrogenSlot
{
	slotName: string;
	productCodes: string[];
	startTime: string;
	endTime: string;
	departureDayOffset?: number;
	type: string;
}


export function getOptionsByLegAndSlot(options: IBundleItem[], legs: IRouteLeg[])
{
	// console.debug("getOptionsByLegAndSlot", options, legs);
	let optionsByLegAndSlot = options.reduce((acc, opt) => {
		const slot = getKrogenSlotForProductCode(opt.productCode);
		const legId = opt.legIds[0];  //Jag tror inte samma option i praktiken kan finnas på flera legs

		//Filtrera bort om man inte kan utnyttja tiden, t.ex. frukost om man åker senare än 10 (eller vad det blir)
		const leg = legs.find(x => legId === x.id);
		const times = getSlotStartAndEndTime(slot, leg.departureStation.departureTimestamp, leg.arrivalStation.arrivalTimestamp);
		if (!times)
			return acc;

		let group = acc.find(x => x.slot.slotName === slot.slotName && x.legId === legId);
		if (!group)
		{
			group = { slot, legId: legId, day: times.start.startOf("day"), options: [] };
			acc.push(group);
		}
		group.options.push(opt);
		return acc;
	}, [] as { slot: IKrogenSlot, legId: string, day: dayjs.Dayjs, options: IBundleItem[] }[]);

	optionsByLegAndSlot.sort((a, b) => {

		//Om de ligger i samma slot behöver de inte sorteras om
		if (a.slot.slotName === b.slot.slotName)
			return 0;

		const aLeg = legs.find(x => x.id == a.legId);
		const bLeg = legs.find(x => x.id == b.legId);

		const aTimes = getSlotStartAndEndTime(a.slot, aLeg.departureStation.departureTimestamp, aLeg.arrivalStation.arrivalTimestamp);
		const bTimes = getSlotStartAndEndTime(b.slot, bLeg.departureStation.departureTimestamp, bLeg.arrivalStation.arrivalTimestamp);

		//Ska inte hända, men det behöver ju inte smälla heller
		if (!aTimes || !bTimes)
			return 0;

		return aTimes.start.isBefore(bTimes.start) ? -1 : 1;
	});

	return optionsByLegAndSlot;
};

export function getSlotStartAndEndTime(slot: IKrogenSlot, departure: string, arrival: string) : { start: dayjs.Dayjs, end: dayjs.Dayjs } | null {
	const dep = dayjs(departure);
	const arr = dayjs(arrival);


	const startTimeParts = slot.startTime.split(':').map(str => parseInt(str)); //[timme,minut]
	const startTime = dayjs.duration({ hours: startTimeParts[0], minutes: startTimeParts[1] });
	const endTimeParts = slot.endTime.split(':').map(str => parseInt(str)); //[timme,minut]
	const endTime = dayjs.duration({ hours: endTimeParts[0], minutes: endTimeParts[1] });

	let day = dep.startOf("day");

	if (slot.departureDayOffset)
		day = day.add(slot.departureDayOffset, "days");


	const start = day.add(startTime);
	const end = day.add(endTime);

	if (end.isBefore(dep) || start.isAfter(arr))
		return null;

	return { start, end };
}